import './AnnouncementBar.css';

import React from 'react';

import { useCustomer } from '@/hooks/useCustomer';
import { cn } from '@/utils';

export const AnnouncementBar: React.FC<{
  announcement: string;
  announcementLoggedIn: string;
  theme: string;
}> = ({ announcement, announcementLoggedIn = '', theme }): JSX.Element => {
  const { customer } = useCustomer();

  let text = announcement.replace(
    /<a/g,
    '<a data-selector="Announcement bar link"',
  );

  if (!!customer && !!announcementLoggedIn && announcementLoggedIn !== '') {
    text = announcementLoggedIn.replace(
      /<a/g,
      '<a data-selector="Announcement bar link"',
    );
  }

  return (
    <p
      className={cn('announcement-bar text-sm', {
        'text-black [--link-color:theme(colors.blue)]': theme === 'White',
        'text-black': theme === 'Yellow',
        'text-green-gloss': theme === 'Green',
        'text-red-gloss': theme === 'Red',
        'text-white [--link-color:theme(colors.white)]':
          theme === 'Blue' || theme === 'Black',
        'text-white': theme === 'Hem X',
      })}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};
